import { template as template_92f45357a30d4bbba7f516fa78840862 } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
const getPreviousUploadFileTasks = (task, taskRepo)=>{
    return taskRepo.getAllPreviousTasks(task).filter((tasks)=>!tasks.isDeleted && tasks.isUploadFile) ?? [];
};
const selectedTaskValueTemplate = template_92f45357a30d4bbba7f516fa78840862(`
<span title={{@option.parent.name}} class="w-100">
  {{#if @option.parent.name}} {{@option.parent.name}} - {{/if}}
  {{@option.name}}
</span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
const taskValueMatcher = (option, term)=>{
    if (!option?.id) {
        return -1;
    }
    const searchTerm = term.toLowerCase();
    const name = option.name?.toLowerCase() ?? '';
    const parentName = option.parent?.name?.toLowerCase() ?? '';
    return name.includes(searchTerm) || parentName.includes(searchTerm) ? 1 : -1;
};
const getUploadTaskOptions = (previousUploadTasks)=>{
    const groups = {};
    for (const task of previousUploadTasks){
        const stationName = task.parent.name;
        if (!groups[stationName]) {
            groups[stationName] = [];
        }
        groups[stationName].push(task);
    }
    const options = [];
    options.push({
        id: null,
        name: 'None'
    });
    for (const station of Object.keys(groups)){
        const stationData = {
            groupName: station,
            options: groups[station]
        };
        options.push(stationData);
    }
    return options;
};
export default class TaskContextConfigViewFile extends Component {
    @service
    taskRepo;
    @tracked
    previousUploadTasks = [];
    @tracked
    options = [];
    constructor(){
        super(...arguments);
        this.initializeOptions();
    }
    initializeOptions() {
        this.previousUploadTasks = getPreviousUploadFileTasks(this.args.task, this.taskRepo);
        this.options = getUploadTaskOptions(this.previousUploadTasks);
    }
    get selectedOption() {
        return this.options.flatMap((group)=>group.options || []).find((opt)=>opt.id === this.args.taskConfig.fileTaskId);
    }
    onChange = (option)=>{
        this.args.taskConfig.fileTaskId = option.id;
    };
    static{
        template_92f45357a30d4bbba7f516fa78840862(`
    <div class="bootstrap-table bg-gray-100 p-3">
      <div class="row form-row header-row mt-2">
        <div class="col-4">
          {{t 'taskConfig.selectUpload'}}
        </div>
      </div>
      <div class="col-4 model-specific">
        <@form.element
          class="file-task"
          @controlType='power-select'
          @options={{this.options}}
          @groupComponent="power-select-group"
          @onChange={{this.onChange}}
          @value={{this.selectedOption}}
          @searchField="name"
        as |el|>
          <el.control
            @triggerClass='form-control-sm'
            @searchEnabled={{true}}
            @searchField="name"
            @matcher={{taskValueMatcher}}
            @selectedItemComponent={{selectedTaskValueTemplate}}
          as |value|>
            <span title={{value.parent.name}} class="w-100">
              {{value.name}}
            </span>
          </el.control>
        </@form.element>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
